import {
	FacilityMaintenanceContact,
	FacilityMaintenanceVendorType,
	FacilityMaintenanceWorkOrder,
	Model
} from ".";

export default class FacilityMaintenanceVendor extends Model {
	get singularNoun() {
		return "vendor";
	}

	get mutations() {
		return {
			contacts: FacilityMaintenanceContact,
			vendorType: FacilityMaintenanceVendorType,
			workOrders: FacilityMaintenanceWorkOrder
		};
	}

	get nameWithType() {
		return `${this.name}${this.vendorType ? ` (${this.vendorType.name})` : ""}`;
	}

	resource() {
		return "facility-maintenance/vendors";
	}
}
